prismanoteApp.filter('zipcode', function () {
  return function(zipcode) {
    if(!zipcode || zipcode === '') {
      return ''
    }
    return zipcode.replace(/([0-9]{4})([a-z]{2})/gi, '$1 $2')
  }
})
